import React, { type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { Breadcrumbs, BreadcrumbLink } from 'legacy/components/Breadcrumbs'
import { useScopedPathname } from 'utils/routing/url.hooks'

export const StoreGroupsListBreadcrumbs: FunctionComponent = ({ children }) => {
  const targetLink = useScopedPathname('store-groups')

  return (
    <Breadcrumbs>
      <BreadcrumbLink to={targetLink}>
        <FormattedMessage id="settings.storeGroups.title" />
      </BreadcrumbLink>
      {children}
    </Breadcrumbs>
  )
}
